import { useGlobalMutation } from '@/state/query-client/hooks';
import { useGlobalQuery } from '@/state/query-client/hooks';
import { useErrorHandler } from '@/hooks/use-error-handler';
import { getPreSignedUrlForUpload, getFileUrl } from '../services/storage.service';
import {
  GetPreSignedUrlForUploadPayload,
  GetPreSignedUrlForUploadResponse,
  GetFileResponse,
} from '../types/storage.types';

export const useGetPreSignedUrlForUpload = () => {
  const { handleError } = useErrorHandler();

  return useGlobalMutation<
    GetPreSignedUrlForUploadResponse,
    Error,
    GetPreSignedUrlForUploadPayload
  >({
    mutationKey: ['getPreSignedUrlForUpload'],
    mutationFn: getPreSignedUrlForUpload,
    onError: (error) => {
      handleError(error, {
        variant: 'destructive',
      });
    },
  });
};

/**
 * Resolve a DMS fileId to a public URL.
 *
 * Caches per fileId for 1 hour so the collection grid doesn't refetch
 * on every render. `enabled: !!fileId` keeps it from firing on empty
 * values.
 */
export const useFileUrl = (fileId: string | null | undefined) => {
  return useGlobalQuery<GetFileResponse>({
    queryKey: ['fileUrl', fileId ?? ''],
    queryFn: () => getFileUrl(fileId!),
    enabled: !!fileId,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};